import { toast } from '@huspy/forge/shared';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { formatToLocalTimeZone } from '@shared/utils';
import useFeatureFlags from '@modules/core/hooks/useFeatureFlags';
import { proposalApi } from '@modules/proposals/api';
import { ProposalPreviewResponseDTO } from '../dto/proposalPreview.dto';

function useGetProposalById<
  TQueryFnData = ProposalPreviewResponseDTO,
  TData = TQueryFnData>(
  id: string,
  select?: (data: ProposalPreviewResponseDTO) => TData
) {
  const { isFeatureActive, isFeatureFlagsLoading } = useFeatureFlags();
  const {
    data, isLoading, error, refetch, isRefetching, isFetched,
  } = useQuery({
    queryKey: ['proposal', id],
    queryFn: () => proposalApi.getProposalByExternalId(id),
    select: (_data) => ({
      ...(select ? select(_data) : _data),
      editable_until: _data.editable_until
        ? formatToLocalTimeZone(_data.editable_until).toISOString() : _data.editable_until,
    } as TData),
    // eslint-disable-next-line max-len
    enabled: !!id && !isFeatureFlagsLoading && isFeatureActive('proposals.module') && !isFeatureActive('proposals.baytecaMVP'),
  });

  useEffect(() => {
    if (error) {
      toast('error', { message: error.message });
    }
  }, [error]);

  return {
    data,
    isLoading,
    isFetched,
    error,
    refetch,
    isRefetching,
  };
}

export default useGetProposalById;
